import React from 'react';

import Localization from '../../../../../../common/edlio-js/models/BackendLocalization';

export default class InputLabel extends React.Component {
	render() {
		const label = this.props.usePlaceholderLabel ? '' : this.props.label;
		const value = label  === 'Option' ? '' : label;
		let placeholder = this.props.placeholder ? this.props.placeholder : 'Question';
		let localization = new Localization(window.edlio.localizations);

		return (
			<div className='label' style={{ width: this.props.width }}>
				<label>
					{this.props.label}
					{ this.props.required &&
						<em className='required-indicator'>*</em>
					}
				</label>
				<input
					style={{ width: this.props.width }}
					ref='input'
					type='text'
					defaultValue={value}
					placeholder={localization.localize(placeholder)}
				></input>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/widgets/input-label.js